import { getMedia, graphqlClient, postRetouchAISingle, postSingleRemoveDust } from "src/api";

import { createRequest } from "urql";
import {
  AI_CHANGE_METAL_MATERIAL,
  AI_LIFESTYLE_IMAGE_TEMPLATES,
  AI_LIFESTYLE_IMAGE,
  AI_MODEL_IMAGE,
  USER_CREATE_GENERATIVE_AI_QUOTA_REFILL_REQUEST,
  USER_FEATURES,
  USER_INFO_SUBSCRIPTION,
  AI_SKIN_TONE_LIST,
  AI_METAL_COLOR_LIST,
} from "src/api/graphql-api/user/user.gql";
import { makeAutoObservable, runInAction } from "mobx";
import { AI_RECOGNITION, MEDIA_INFO } from "src/api/graphql-api/product/product.gql";

class GenerativeAiStore {
  private _showSelectGoldColor: boolean = false;
  private _showSelectLifestyleBg: boolean = false;
  private _isOutOfQuota: boolean = false;
  private _showSlowTips: boolean = false;
  private _remindSlowTips: boolean = false;
  private _aiToolType: string = "model_image_pro";
  private _aiStyle: string = "";
  private _gemStudioCredits: number = 0;
  private _autoGemStudio: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  public get showSelectGoldColor() {
    return this._showSelectGoldColor;
  }

  public toggleShowSelectGoldColor = (value: boolean) => {
    runInAction(() => {
      this._showSelectGoldColor = value;
    });
  };

  public get showSelectLifestyleBg() {
    return this._showSelectLifestyleBg;
  }

  public toggleShowSelectLifestyleBg = (value: boolean) => {
    runInAction(() => {
      this._showSelectLifestyleBg = value;
    });
  };

  public get isOutOfQuota() {
    return this._isOutOfQuota;
  }

  public toggleIsOutOfQuota = (value: boolean) => {
    runInAction(() => {
      this._isOutOfQuota = value;
    });
  };

  public get showSlowTips() {
    return this._showSlowTips;
  }

  public toggleShowSlowTips = (value: boolean) => {
    runInAction(() => {
      this._showSlowTips = value;
    });
  };

  public get remindSlowTips() {
    return this._remindSlowTips;
  }

  public toggleRemindSlowTips = (value: boolean) => {
    runInAction(() => {
      this._remindSlowTips = value;
    });
  };

  public get aiToolType() {
    return this._aiToolType;
  }

  public setAiToolType = (value: string) => {
    runInAction(() => {
      this._aiToolType = value;
    });
  };

  public get aiStyle() {
    return this._aiStyle;
  }

  public setAiStyle = (value: string) => {
    runInAction(() => {
      this._aiStyle = value;
    });
  };

  public get gemStudioCredits() {
    return this._gemStudioCredits;
  }

  public setGemStudioCredits = (value: number) => {
    runInAction(() => {
      this._gemStudioCredits = value;
    });
  };

  public get autoGemStudio() {
    return this._autoGemStudio;
  }

  public setAutoGemStudio = (value: boolean) => {
    runInAction(() => {
      this._autoGemStudio = value;
    });
  };

  public async userFeatures() {
    let res = await graphqlClient.executeQuery(createRequest(USER_FEATURES, {})).toPromise();
    return res?.data?.userFeatures?.data || [];
  }

  public async userInfoSubscription() {
    let res = await graphqlClient
      .executeQuery(createRequest(USER_INFO_SUBSCRIPTION, {}))
      .toPromise();
    return res?.data?.userInfo || {};
  }

  public async aiLifestyleImageTemplates() {
    let res = await graphqlClient
      .executeQuery(createRequest(AI_LIFESTYLE_IMAGE_TEMPLATES, {}))
      .toPromise();
    return res?.data?.aiLifestyleImageTemplates?.data || [];
  }

  public async aiSkinToneList() {
    let res = await graphqlClient.executeQuery(createRequest(AI_SKIN_TONE_LIST, {})).toPromise();
    return res?.data?.aiSkinToneList?.data || [];
  }

  public async aiMetalColorList() {
    let res = await graphqlClient.executeQuery(createRequest(AI_METAL_COLOR_LIST, {})).toPromise();
    return res?.data?.aiMetalColorList?.data || [];
  }

  public async contactUsForQuota() {
    let res = await graphqlClient
      .executeMutation(createRequest(USER_CREATE_GENERATIVE_AI_QUOTA_REFILL_REQUEST, {}))
      .toPromise();
    return res?.data?.userCreateGenerativeAIQuotaRefillRequest?.data;
  }

  public async mediaInfo() {
    let res = await graphqlClient.executeQuery(createRequest(MEDIA_INFO, {})).toPromise();
    return res?.data?.mediaInfo?.data || {};
  }

  public async aiRecognition(id: any) {
    let res = await graphqlClient
      .executeMutation(
        createRequest(AI_RECOGNITION, {
          guid: `${+new Date()}`,
          mediaId: +id,
          language: "en",
          cacheFirst: true,
          type: "",
        }),
      )
      .toPromise();
    return res?.data?.aiRecognition;
  }
}

export const generativeAiStore = new GenerativeAiStore();
